/**
 * Grupos e módulos do menu do ERP.
 *
 * Cada módulo aponta para uma rota que já existe em routes/index.jsx. O campo
 * `permissao` espelha o que a rota já exige (PrivateRoute): o menu só esconde o
 * que a própria rota já barraria. Não cria endereço novo.
 */
export const GRUPOS = [
  {
    id: 'inicio',
    rotulo: 'Início',
    icone: 'home',
    modulos: [
      { rotulo: 'Home', icone: 'home', rota: '/' },
      { rotulo: 'Dashboard', icone: 'monitoring', rota: '/dashboard', permissao: 'dashboard' },
    ],
  },
  {
    id: 'operacao',
    rotulo: 'Operação',
    icone: 'folder_open',
    modulos: [
      { rotulo: 'Processos', icone: 'gavel', rota: '/juridico', permissao: 'juridico' },
      { rotulo: 'Agenda', icone: 'event', rota: '/agenda' },
      { rotulo: 'Kanban', icone: 'view_kanban', rota: '/kanban' },
    ],
  },
  {
    id: 'gestao',
    rotulo: 'Gestão',
    icone: 'business_center',
    modulos: [
      { rotulo: 'Clientes', icone: 'groups', rota: '/crm', permissao: 'crm' },
      { rotulo: 'Propostas', icone: 'request_quote', rota: '/propostas', permissao: 'crm' },
      { rotulo: 'Assinaturas', icone: 'signature', rota: '/contratos', permissao: 'crm' },
      { rotulo: 'Financeiro', icone: 'payments', rota: '/financeiro', permissao: 'financeiro' },
    ],
  },
  {
    id: 'ferramentas',
    rotulo: 'Ferramentas',
    icone: 'handyman',
    modulos: [
      { rotulo: 'Documentos', icone: 'description', rota: '/documentos', permissao: 'documentos' },
      { rotulo: 'Formulários', icone: 'dynamic_form', rota: '/formularios' },
      { rotulo: 'Radar legislativo', icone: 'radar', rota: '/radar', permissao: 'radar' },
      { rotulo: 'Jurisprudência', icone: 'menu_book', rota: '/jurisprudencia', permissao: 'jurisprudencia' },
      { rotulo: 'Consultas', icone: 'travel_explore', rota: '/consultas' },
    ],
  },
  {
    id: 'comunicacao',
    rotulo: 'Comunicação',
    icone: 'forum',
    modulos: [
      { rotulo: 'Alertas', icone: 'notifications_active', rota: '/alertas' },
      { rotulo: 'WhatsApp', icone: 'chat', rota: '/whatsapp', permissao: 'atendimento' },
      { rotulo: 'Painel do atendimento', icone: 'monitoring', rota: '/whatsapp/painel', permissao: 'atendimento' },
    ],
  },
  {
    id: 'configuracoes',
    rotulo: 'Configurações',
    icone: 'settings',
    modulos: [
      { rotulo: 'Configurações', icone: 'apartment', rota: '/configuracoes', permissao: 'configuracoes' },
      { rotulo: 'Equipe', icone: 'badge', rota: '/equipe', permissao: 'equipe' },
      // Logs saíram daqui em 31/10/2026: são a seção Logs do Bunker (/admin).
    ],
  },
];

/** Grupos e módulos que este usuário pode abrir. Grupo sem módulo some. */
export function gruposVisiveis(temPermissao, usuario) {
  return GRUPOS
    .map((grupo) => ({
      ...grupo,
      modulos: grupo.modulos.filter((m) => (
        (!m.permissao || temPermissao(m.permissao))
        && (!m.somenteMaster || Boolean(usuario?.is_master))
      )),
    }))
    .filter((grupo) => grupo.modulos.length > 0);
}

/** Módulo que contém o endereço atual (ex.: /configuracoes/etiquetas → Configurações). */
export function moduloDaRota(pathname, grupos) {
  // Endereço exato primeiro: /whatsapp/painel é o Painel, não o WhatsApp.
  for (const grupo of grupos) {
    const exato = grupo.modulos.find((m) => pathname === m.rota);
    if (exato) return { grupo, modulo: exato };
  }
  for (const grupo of grupos) {
    const modulo = grupo.modulos.find((m) => pathname === m.rota || pathname.startsWith(`${m.rota}/`));
    if (modulo) return { grupo, modulo };
  }
  return null;
}
